export const AccountType = {
    CLIENT: 'client',
    OWNER: 'owner',
    SUPPORT: 'Support',
    SUPPORTPLUS: 'Support Plus',
    TRANSLATER: 'Translator',
    ADMIN: 'admin',
    MEMBER: 'member'
}

export const AccountStatus = {
    ACTIVE: 'Active',
    PAUSED: 'Paused',
    TEST: 'Test'
}

export const CouponStatus = {
    ACTIVE: 'active',
    DEACTIVATED: 'deactivated',
}


export const BankPaymentDetails = [
    { title: "Beneficiary Name", value: "eVerbary LLC" },
    { title: "Routing Number", value: "091311229" },
    { title: "Account Number", value: "202293114598" },
    { title: "Type of Account", value: "Checking" },
    {
      title: "Beneficiary Address",
      value: "1209 Mountain Road Pl NE Ste N, Albuquerque, NM 87110",
    },
    { title: "Bank", value: "Choice Financial Group" },
    {
      title: "Bank Address",
      value: "4501 23rd Avenue S, Fargo, ND 58104",
    },
  ];


export const EAST1 = "us-east1";
export const EAST4 = "us-east4";
export const WEST3= "us-east1";
export const CENTRAL1= "us-east1";